import React from 'react';
import { Copy, Stack, SvgPencil } from '@grubhubprod/gh-cookbook-react';
import { DataTable } from 'src/components/DataTable';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

export interface EmployeeListTableDetailsLinkProps {
  href: string;
}

export function EmployeeListTableDetailsLink({
  href,
}: EmployeeListTableDetailsLinkProps): JSX.Element {
  return (
    <Tooltip
      roundedContainer
      content={
        <Copy variant="body" color="invertedPrimaryText">
          Edit
        </Copy>
      }
    >
      <Stack>
        <DataTable.Link href={href}>
          <SvgPencil size="24px" aria-label="Employee Edit" />
        </DataTable.Link>
      </Stack>
    </Tooltip>
  );
}
